import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Routes } from '@angular/router';
import { LogoutComponent } from './logout/logout.component';
import { PlatformIdmCanActivate, PlatformIdmCreateSessionComponent } from '@platform-idm/sdk-angular';
import { LoginComponent } from './login/login.component';

export const routes: Routes = [
  { path: '', redirectTo: 'mx', pathMatch: 'full' },

  { path: 'mx', loadChildren: () => import('./modules/mx/mx.module').then(m => m.MXModule) },
  { path: 'medifoxdan', loadChildren: () => import('./modules/medifoxdan/medifoxdan.module').then(m => m.MedifoxdanModule) },
  { path: 'citus', loadChildren: () => import('./modules/citus/citus.module').then(m => m.CitusModule)},
  { path: 'multicare', loadChildren: () => import('./modules/multicare/multicare.module').then(m => m.MulticareModule) },
  { path: 'resmed', loadChildren: () => import('./modules/resmed/resmed.module').then(m => m.ResmedModule) },


  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'create-session', component: PlatformIdmCreateSessionComponent },
  {
    path: 'secured',
    loadChildren: () => import('./secured/secured.module').then(m => m.SecuredModule)
  },
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
